import React, { Component, Fragment } from 'react';
import map from 'lodash.map';
import filter from 'lodash.filter';
import orderBy from 'lodash.orderby';
import isEmpty from 'lodash.isempty';
import isEqual from 'lodash.isequal';
import { BudgetListItem } from './BudgetListItem';
import { Loader } from '../../Loader';
import { Pagination } from '../../Pagination';
import { Select } from '../../Select';
import { PaginationSelect } from '../../PaginationSelect';
import {
	BudgetYearDropdownOption,
	DistrictDropdownOption,
	ThematicAreaDropdownOption,
	ProjectTaskStatusDropdownOption,
	ExpendActionType,
	ProjectType,
	DefaultOffice
} from '../../../utils/enums';
import {ButtonLoader} from "../../ButtonLoader";

export class BudgetList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			opened: true,
			archiveOpened: false,
			budgetYearId: BudgetYearDropdownOption.NotSetted,
			districtId: DistrictDropdownOption.NotSetted,
			officeThematicAreaId: ThematicAreaDropdownOption.NotSetted,
			status: ProjectTaskStatusDropdownOption.NotSetted,
			searchTerm: '',
			page: 1,
			size: props.size
		};
		this.handlePageSizeChanged = this.handlePageSizeChanged.bind(this);
		this.handleArchivePageSizeChanged = this.handleArchivePageSizeChanged.bind(this);
		this.toggleOpen = (e) => {
			e.preventDefault();
			e.stopPropagation();
			const propertyName = this.getPropertyName(ProjectType.PublicBudget, true);
			this.setExpandStateItem(
				propertyName,
				!this.state.archiveOpened ? ExpendActionType.add : ExpendActionType.remove,
				-1
			);
		};

		this.handleSelect = (fieldName, option) => {
			this.setState({
				[fieldName]: parseInt(option.value)
			});
		};
		this.handleChange = (event) => {
			this.setState({
				searchTerm: event.target.value
			});
		};
		this.handleInvalid = this._handleInvalid.bind(this);
		this.onSearchProjectTask = (e) => {
			e.preventDefault();
			this.props.onSearchProjectTask({
				budgetYearId: this.state.budgetYearId,
				districtId: this.state.districtId,
				officeThematicAreaId: this.state.officeThematicAreaId,
				status: this.state.status,
				searchTerm: this.state.searchTerm,
				page: 1,
				size: this.state.size
			});
		};

		this.getPropertyName = this.getPropertyName.bind(this);
		this.setExpandStateItem = this.setExpandStateItem.bind(this);
	}
	componentDidMount() {
		const oldPropertyName = this.getPropertyName(ProjectType.PublicBudget, true);
		const archiveOpened = this.props.expand[oldPropertyName].some((item) => item === -1);
		this.setState({
			archiveOpened: archiveOpened
		});
	}
	componentDidUpdate(prevProps) {
		if (!isEqual(prevProps.expand, this.props.expand)) {
			const oldPropertyName = this.getPropertyName(ProjectType.PublicBudget, true);
			const archiveOpened = this.props.expand[oldPropertyName].some((item) => item === -1);

			this.setState({
				archiveOpened: archiveOpened
			});
		}
	}
	paginationGoTo(filter) {
		this.props.onSearchProject(filter);
	}

	handlePageSizeChanged(option) {
		this.props.changePageSize(option.value);
	}

	handleArchivePageSizeChanged(option) {
		this.props.changeArchivePageSize(option.value);
	}

	_handleInvalid(e) {
		e.target.setCustomValidity('');
		if (!e.target.validity.valid) {
			if (!e.target.value) {
				e.target.setCustomValidity('Pole jest wymagane');
			} else if (e.target.value.length < 3) {
				e.target.setCustomValidity('Minimalna długość zapytania to 3 znaki');
			}
		}
	}

	renderDistrictOptions() {
		const notSetted = { value: DistrictDropdownOption.NotSetted, text: '[Wszystkie obszary]' };
		const options = map(this.props.districts, (district, i) => ({
			value: district.id,
			text: district.name
		})).sort((a, b) => a.text.localeCompare(b.text, 'pl'));

		return [ notSetted, ...options ];
	}
	renderBudgetYearOptions() {
		const notSetted = { value: BudgetYearDropdownOption.NotSetted, text: '[Wszystkie lata]' };
		const options = orderBy(
			map(this.props.budgetYears, (budgetYear, i) => ({
				value: budgetYear.id,
				text: budgetYear.year
			})),
			[ 'text' ]
		);

		return [ notSetted, ...options ];
	}
	renderOfficeThematicAreaOptions() {
		const notSetted = { value: ThematicAreaDropdownOption.NotSetted, text: '[Wszystkie kategorie]' };
		const options = map(
			filter(this.props.officeThematicAreas, { officeId: this.props.defaultOffice.id }),
			(officeThematicArea, i) => ({
				value: officeThematicArea.id,
				text: officeThematicArea.name
			})
		).sort((a, b) => a.text.localeCompare(b.text, 'pl'));

		return [ notSetted, ...options ];
	}

	renderStatusOptions() {
		const notSetted = { value: ProjectTaskStatusDropdownOption.NotSetted, text: '[Wszystkie statusy]' };
		const options = map(filter(this.props.projectTaskStatuses, (o) => o.id > 0), (projectTaskStatus, i) => ({
			value: projectTaskStatus.id,
			text: projectTaskStatus.name
		})).sort((a, b) => a.text.localeCompare(b.text, 'pl'));

		return [ notSetted, ...options ];
	}

	getPropertyName(type, isOld) {
		let propertyName = '';
		switch (type) {
			case ProjectType.Probe: {
				propertyName = !isOld ? 'probes' : 'oldprobes';
				break;
			}
			case ProjectType.Consultation: {
				propertyName = !isOld ? 'consultations' : 'oldconsultations';
				break;
			}
			case ProjectType.Survey: {
				propertyName = !isOld ? 'surveys' : 'oldsurveys';
				break;
			}
			case ProjectType.PublicBudget: {
				propertyName = !isOld ? 'budgets' : 'oldbudgets';
				break;
			}
			default: {
				propertyName = '';
				break;
			}
		}
		return propertyName;
	}

	setExpandStateItem(propertyName, action, id) {
		this.props.onSetExpandStateItem(action, propertyName, id);
	}

	render() {
		const {
			budgets,
			archiveBudgets,
			isBudgetLoading,
			page = 1,
			budgetTotals = 0,
			size = 10,
			archiveListPage = 1,
			archiveListSize = 10,
			isAuth,
			loggedOfficeId,
			archiveBudgetTotals,
			isArchiveBudgetLoading,
			isOnlyOneOffice,
			isProjectTaskSearching,
			onSetExpandStateItem,
			expand
		} = this.props;

		const { archiveOpened } = this.state;
		const totalPages = Math.ceil(budgetTotals / size);
		const totalArchivesPages = Math.ceil(archiveBudgetTotals / archiveListSize);
		const budgetYearOptions = this.renderBudgetYearOptions();
		const districtOptions = this.renderDistrictOptions();
		const officeThematicAreaOptions = this.renderOfficeThematicAreaOptions();
		const statusOptions = this.renderStatusOptions();

		return (
			<Fragment>
				{isBudgetLoading && <Loader loading={isBudgetLoading} />}
				{!isBudgetLoading && (
					<Fragment>
					<div id="content" className="container consultations">
							<form onSubmit={this.onSearchProjectTask}>
								<div className="row row--justify-end row--space-10 row--top-15 row--bottom-20 project-tasks__header">
									<Select
										options={budgetYearOptions}
										value={this.state.budgetYearId}
										onSelect={(option) => this.handleSelect('budgetYearId', option)}
									/>
									<Select
										options={districtOptions}
										value={this.state.districtId}
										onSelect={(option) => this.handleSelect('districtId', option)}
									/>
									<Select
										options={officeThematicAreaOptions}
										value={this.state.officeThematicAreaId}
										onSelect={(option) => this.handleSelect('officeThematicAreaId', option)}
									/>
									<Select
										options={statusOptions}
										value={this.state.status}
										onSelect={(option) => this.handleSelect('status', option)}
									/>
									<div className="field">
										<input
											className="field__input"
											placeholder="Słowa kluczowe"
											title="Wpisz słowa kluczowe"
											type="text"
											value={this.state.searchTerm}
											onChange={this.handleChange.bind(this)}
											pattern=".{3,}"
											onInvalid={this.handleInvalid}
										/>
									</div>
									{!isProjectTaskSearching && (
										<button
											id="search-button"
											className="button button--primary-dark button--16 button--width-auto"
											type="submit"
											tabIndex="0"
											title="Wyszukaj z zastosowanymi filtrami"
										>
											<span aria-hidden="true">Wyszukaj</span>
										</button>
									)}
									{isProjectTaskSearching && (
										<ButtonLoader
											isExecuting={isProjectTaskSearching}
											executingText="Szukanie"
											color={'#fff'}
										/>
									)}
								</div>
							</form>
							{map(orderBy(budgets, [ 'budgetYearValue', 'status' ], [ 'desc', 'asc' ]), (budget) => {
								const propertyName = this.getPropertyName(ProjectType.PublicBudget, false);
								const opened = expand[propertyName].some((item) => item === budget.id);
								return (
									<BudgetListItem
										key={`actual-budget-list-item-${budget.id}`}
										{...budget}
										isAuth={isAuth}
										loggedOfficeId={loggedOfficeId}
										goToProject={() => this.props.onProjectDetails(budget)}
										opened={opened}
										onProjectPreview={this.props.onProjectPreview}
										onProjectVote={this.props.onProjectVote}
										isOnlyOneOffice={isOnlyOneOffice}
										onSetExpandStateItem={(action, id) =>
											this.setExpandStateItem(propertyName, action, id)}
									/>
								);
							})}
							{!isEmpty(budgets) && (
								<div className="projects__pagination row row--align-center row--justify-space row--top-20">
									<PaginationSelect onPageSizeChanged={this.handlePageSizeChanged} size={size} />
									<Pagination
										currentPage={parseInt(page)}
										totalPages={totalPages}
										nextAction={() =>
											this.paginationGoTo({
												isActual: true,
												page: parseInt(page) + 1,
												size: parseInt(size),
												archiveListPage: parseInt(archiveListPage),
												archiveListSize: parseInt(archiveListSize)
											})}
										prevAction={() =>
											this.paginationGoTo({
												isActual: true,
												page: parseInt(page) - 1,
												size: parseInt(size),
												archiveListPage: parseInt(archiveListPage),
												archiveListSize: parseInt(archiveListSize)
											})}
									/>
								</div>
							)}
						</div>
						<div className="container consultations">
							<div className="consultations__item">
								<div className={`consultations__header`} onClick={this.toggleOpen}>
									<div className="consultations__title">Budżet obywatelski w latach ubiegłych</div>
									<div className="consultations__icons">
										<div className="consultations__switch consultations__switch--primary-dark" onClick={this.toggleOpen}>
											{archiveOpened ? 'Zwiń' : 'Rozwiń'}
											{
												<i
													className={`consultations__icon fas fa-angle-${archiveOpened
														? 'up'
														: 'down'}`}
												/>
											}
										</div>
									</div>
								</div>
								{isArchiveBudgetLoading && archiveOpened && <Loader loading={isArchiveBudgetLoading} />}
								{!isArchiveBudgetLoading &&
								archiveOpened && (
									<div className="consultations__body">
										{archiveBudgetTotals === 0 && (
											<div className="text text--weight-700">
												Brak projektów spełniających warunek
											</div>
										)}
										{map(
											orderBy(archiveBudgets, [ 'budgetYearValue', 'status' ], [ 'desc', 'asc' ]),
											(budget) => {
												const propertyName = this.getPropertyName(
													ProjectType.PublicBudget,
													true
												);
												const opened = expand[propertyName].some((item) => item === budget.id);
												return (
													<BudgetListItem
														key={`archive-budget-list-item-${budget.id}`}
														{...budget}
														opened={opened}
														isAuth={isAuth}
														loggedOfficeId={loggedOfficeId}
														goToProject={() => this.props.onProjectDetails(budget)}
														isActual={false}
														onProjectPreview={this.props.onProjectPreview}
														onProjectVote={this.props.onProjectVote}
														isOnlyOneOffice={isOnlyOneOffice}
														onSetExpandStateItem={(action, id) =>
															this.setExpandStateItem(propertyName, action, id)}
													/>
												);
											}
										)}

										<div className="projects__pagination row row--align-center row--justify-space row--top-20">
											<PaginationSelect
												onPageSizeChanged={this.handleArchivePageSizeChanged}
												size={archiveListSize}
											/>
											<Pagination
												currentPage={parseInt(archiveListPage)}
												totalPages={totalArchivesPages}
												nextAction={() =>
													this.props.onSearchArchiveProject({
														isActual: false,
														page: parseInt(page),
														size: parseInt(size),
														archiveListPage: parseInt(archiveListPage) + 1,
														archiveListSize: parseInt(archiveListSize)
													})}
												prevAction={() =>
													this.props.onSearchArchiveProject({
														isActual: false,
														page: parseInt(page),
														size: parseInt(size),
														archiveListPage: parseInt(archiveListPage) - 1,
														archiveListSize: parseInt(archiveListSize)
													})}
											/>
										</div>
									</div>
								)}
							</div>
						</div>
					</Fragment>
				)}
			</Fragment>
		);
	}
}
BudgetList.defaultProps = {
	isBudgetLoading: false,
	isArchiveBudgetLoading: false,
	budgets: [],
	archiveBudgets: [],
	isAuth: false,
	loggedOfficeId: DefaultOffice.NotSetted,
	page: 1,
	size: 10,
	archiveListPage: 1,
	archiveListSize: 10,
	budgetTotals: 0,
	archiveBudgetTotals: 0,
	isOnlyOneOffice: false,
	districts: [],
	budgetYears: [],
	officeThematicAreas: [],
	projectTaskStatuses: [],
	onProjectDetails: Function.prototype,
	onProjectPreview: Function.prototype,
	onProjectVote: Function.prototype,
	onSearchProject: Function.prototype,
	onSearchArchiveProject: Function.prototype,
	changePageSize: Function.prototype,
	changeArchivePageSize: Function.prototype
};
